module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "val": _vm.val,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.val === _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', _vm.value)
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._t("label")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d001236"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utils/Inputs/Radio.vue
// module id = 799
// module chunks = 1